import _dateCd1c23ce from "./date-cd1c23ce.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: !0
});

const t = t => "[object Object]" === Object.prototype.toString.call(t),
      e = (t, e) => {
  const s = document.createElement(t);
  if (e && "object" == typeof e) for (const t in e) "html" === t ? s.innerHTML = e[t] : s.setAttribute(t, e[t]);
  return s;
},
      s = t => {
  t instanceof NodeList || t instanceof Object && Object.prototype.hasOwnProperty.call(t, "length") ? t.forEach(t => s(t)) : t.innerHTML = "";
},
      a = (t, s, a) => e("li", {
  class: t,
  html: `<a href="#" data-page="${s}">${a}</a>`
}),
      i = (t, e) => {
  let s, a;
  1 === e ? (s = 0, a = t.length) : -1 === e && (s = t.length - 1, a = -1);

  for (let i = !0; i;) {
    i = !1;

    for (let n = s; n != a; n += e) if (t[n + e] && t[n].value > t[n + e].value) {
      const s = t[n],
            a = t[n + e],
            l = s;
      t[n] = a, t[n + e] = l, i = !0;
    }
  }

  return t;
};

class n {
  constructor(t, e) {
    return this.dt = t, this.rows = e, this;
  }

  build(t) {
    const s = e("tr");
    let a = this.dt.headings;
    return a.length || (a = t.map(() => "")), a.forEach((a, i) => {
      const n = e("td");
      t[i] && t[i].length || (t[i] = ""), n.innerHTML = t[i], n.data = t[i], s.appendChild(n);
    }), s;
  }

  render(t) {
    return t;
  }

  add(t) {
    if (Array.isArray(t)) {
      const e = this.dt;
      Array.isArray(t[0]) ? t.forEach(t => {
        e.data.push(this.build(t));
      }) : e.data.push(this.build(t)), e.data.length && (e.hasRows = !0), this.update(), e.columns().rebuild();
    }
  }

  remove(t) {
    const e = this.dt;
    Array.isArray(t) ? (t.sort((t, e) => e - t), t.forEach(t => {
      e.data.splice(t, 1);
    })) : "all" == t ? e.data = [] : e.data.splice(t, 1), e.data.length || (e.hasRows = !1), this.update(), e.columns().rebuild();
  }

  update() {
    this.dt.data.forEach((t, e) => {
      t.dataIndex = e;
    });
  }

}

class l {
  constructor(t) {
    return this.dt = t, this;
  }

  swap(t) {
    if (t.length && 2 === t.length) {
      const e = [];
      this.dt.headings.forEach((t, s) => {
        e.push(s);
      });
      const s = t[0],
            a = t[1],
            i = e[a];
      e[a] = e[s], e[s] = i, this.order(e);
    }
  }

  order(t) {
    let e, s, a, i, n, l, r;
    const h = [[], [], [], []],
          o = this.dt;
    t.forEach((t, a) => {
      n = o.headings[t], l = "false" !== n.getAttribute("data-sortable"), e = n.cloneNode(!0), e.originalCellIndex = a, e.sortable = l, h[0].push(e), o.hiddenColumns.includes(t) || (s = n.cloneNode(!0), s.originalCellIndex = a, s.sortable = l, h[1].push(s));
    }), o.data.forEach((e, s) => {
      a = e.cloneNode(!1), i = e.cloneNode(!1), a.dataIndex = i.dataIndex = s, null !== e.searchIndex && void 0 !== e.searchIndex && (a.searchIndex = i.searchIndex = e.searchIndex), t.forEach(t => {
        r = e.cells[t].cloneNode(!0), r.data = e.cells[t].data, a.appendChild(r), o.hiddenColumns.includes(t) || (r = e.cells[t].cloneNode(!0), r.data = e.cells[t].data, i.appendChild(r));
      }), h[2].push(a), h[3].push(i);
    }), o.headings = h[0], o.activeHeadings = h[1], o.data = h[2], o.activeRows = h[3], o.update();
  }

  hide(t) {
    if (t.length) {
      const e = this.dt;
      t.forEach(t => {
        e.hiddenColumns.includes(t) || e.hiddenColumns.push(t);
      }), this.rebuild();
    }
  }

  show(t) {
    if (t.length) {
      let e;
      const s = this.dt;
      t.forEach(t => {
        e = s.hiddenColumns.indexOf(t), e > -1 && s.hiddenColumns.splice(e, 1);
      }), this.rebuild();
    }
  }

  visible(t) {
    let e;
    const s = this.dt;
    return t = t || s.headings.map(t => t.originalCellIndex), isNaN(t) ? Array.isArray(t) && (e = [], t.forEach(t => {
      e.push(!s.hiddenColumns.includes(t));
    })) : e = !s.hiddenColumns.includes(t), e;
  }

  add(t) {
    let e;
    const s = document.createElement("th");
    if (!this.dt.headings.length) return this.dt.insert({
      headings: [t.heading],
      data: t.data.map(t => [t])
    }), void this.rebuild();
    this.dt.hiddenHeader ? s.innerHTML = "" : t.heading.nodeName ? s.appendChild(t.heading) : s.innerHTML = t.heading, this.dt.headings.push(s), this.dt.data.forEach((s, a) => {
      t.data[a] && (e = document.createElement("td"), t.data[a].nodeName ? e.appendChild(t.data[a]) : e.innerHTML = t.data[a], e.data = e.innerHTML, t.render && (e.innerHTML = t.render.call(this, e.data, e, s)), s.appendChild(e));
    }), t.type && s.setAttribute("data-type", t.type), t.format && s.setAttribute("data-format", t.format), t.hasOwnProperty("sortable") && (s.sortable = t.sortable, s.setAttribute("data-sortable", !0 === t.sortable ? "true" : "false")), this.rebuild(), this.dt.renderHeader();
  }

  remove(t) {
    Array.isArray(t) ? (t.sort((t, e) => e - t), t.forEach(t => this.remove(t))) : (this.dt.headings.splice(t, 1), this.dt.data.forEach(e => {
      e.removeChild(e.cells[t]);
    })), this.rebuild();
  }

  filter(t, e, s, a) {
    const i = this.dt;

    if (i.filterState || (i.filterState = {
      originalData: i.data
    }), !i.filterState[t]) {
      const e = [...a, () => !0];

      i.filterState[t] = function () {
        let t = 0;
        return () => e[t++ % e.length];
      }();
    }

    const n = i.filterState[t](),
          l = Array.from(i.filterState.originalData).filter(e => {
      const s = e.cells[t],
            a = s.hasAttribute("data-content") ? s.getAttribute("data-content") : s.innerText;
      return "function" == typeof n ? n(a) : a === n;
    });
    i.data = l, this.rebuild(), i.update(), s || i.emit("datatable.sort", t, e);
  }

  sort(t, e, s) {
    const a = this.dt;
    if (a.hasHeadings && (t < 0 || t > a.headings.length)) return !1;
    const n = a.options.filters && a.options.filters[a.headings[t].textContent];
    if (n && 0 !== n.length) return void this.filter(t, e, s, n);
    a.sorting = !0, s || a.emit("datatable.sorting", t, e);
    let l = a.data;
    const r = [],
          h = [];
    let o = 0,
        d = 0;
    const c = a.headings[t],
          p = [];

    if ("date" === c.getAttribute("data-type")) {
      let t = !1;
      c.hasAttribute("data-format") && (t = c.getAttribute("data-format")), p.push(Promise.resolve().then(function () {
        return _dateCd1c23ce;
      }).then(({
        parseDate: e
      }) => s => e(s, t)));
    }

    Promise.all(p).then(n => {
      const p = n[0];
      let g, u;
      Array.from(l).forEach(e => {
        const s = e.cells[t],
              a = s.hasAttribute("data-content") ? s.getAttribute("data-content") : s.innerText;
        let i;
        i = p ? p(a) : "string" == typeof a ? a.replace(/(\$|,|\s|%)/g, "") : a, parseFloat(i) == i ? h[d++] = {
          value: Number(i),
          row: e
        } : r[o++] = {
          value: "string" == typeof a ? a.toLowerCase() : a,
          row: e
        };
      }), e || (e = c.classList.contains("asc") ? "desc" : "asc"), "desc" == e ? (g = i(r, -1), u = i(h, -1), c.classList.remove("asc"), c.classList.add("desc")) : (g = i(h, 1), u = i(r, 1), c.classList.remove("desc"), c.classList.add("asc")), a.lastTh && c != a.lastTh && (a.lastTh.classList.remove("desc"), a.lastTh.classList.remove("asc")), a.lastTh = c, l = g.concat(u), a.data = [];
      const f = [];
      l.forEach((t, e) => {
        a.data.push(t.row), null !== t.row.searchIndex && void 0 !== t.row.searchIndex && f.push(e);
      }), a.searchData = f, this.rebuild(), a.update(), s || a.emit("datatable.sort", t, e);
    });
  }

  rebuild() {
    let t, e, s, a;
    const i = this.dt,
          n = [];
    i.activeRows = [], i.activeHeadings = [], i.headings.forEach((t, e) => {
      t.originalCellIndex = e, t.sortable = "false" !== t.getAttribute("data-sortable"), i.hiddenColumns.includes(e) || i.activeHeadings.push(t);
    }), i.data.forEach((l, r) => {
      t = l.cloneNode(!1), e = l.cloneNode(!1), t.dataIndex = e.dataIndex = r, null !== l.searchIndex && void 0 !== l.searchIndex && (t.searchIndex = e.searchIndex = l.searchIndex), Array.from(l.cells).forEach(n => {
        s = n.cloneNode(!0), s.data = n.data, t.appendChild(s), i.hiddenColumns.includes(s.cellIndex) || (a = s.cloneNode(!0), a.data = s.data, e.appendChild(a));
      }), n.push(t), i.activeRows.push(e);
    }), i.data = n, i.update();
  }

}

const r = function (t) {
  let s = !1,
      a = !1;

  if ((t = t || this.options.data).headings) {
    s = e("thead");
    const a = e("tr");
    t.headings.forEach(t => {
      const s = e("th", {
        html: t
      });
      a.appendChild(s);
    }), s.appendChild(a);
  }

  t.data && t.data.length && (a = e("tbody"), t.data.forEach(s => {
    if (t.headings && t.headings.length !== s.length) throw new Error("The number of rows do not match the number of headings.");
    const i = e("tr");
    s.forEach(t => {
      const s = e("td", {
        html: t
      });
      i.appendChild(s);
    }), a.appendChild(i);
  })), s && (null !== this.table.tHead && this.table.removeChild(this.table.tHead), this.table.appendChild(s)), a && (this.table.tBodies.length && this.table.removeChild(this.table.tBodies[0]), this.table.appendChild(a));
},
      h = {
  sortable: !0,
  searchable: !0,
  paging: !0,
  perPage: 10,
  perPageSelect: [5, 10, 15, 20, 25],
  nextPrev: !0,
  firstLast: !1,
  prevText: "&lsaquo;",
  nextText: "&rsaquo;",
  firstText: "&laquo;",
  lastText: "&raquo;",
  ellipsisText: "&hellip;",
  ascText: "\u25B4",
  descText: "\u25BE",
  truncatePager: !0,
  pagerDelta: 2,
  scrollY: "",
  fixedColumns: !0,
  fixedHeight: !1,
  header: !0,
  footer: !1,
  labels: {
    placeholder: "Search...",
    perPage: "{select} entries per page",
    noRows: "No entries found",
    info: "Showing {start} to {end} of {rows} entries"
  },
  layout: {
    top: "{select}{search}",
    bottom: "{info}{pager}"
  }
};

class o {
  constructor(t, e = {}) {
    if (this.initialized = !1, this.options = { ...h,
      ...e,
      layout: { ...h.layout,
        ...e.layout
      },
      labels: { ...h.labels,
        ...e.labels
      }
    }, "string" == typeof t && (t = document.querySelector(t)), this.initialLayout = t.innerHTML, this.initialSortable = this.options.sortable, this.options.header || (this.options.sortable = !1), null === t.tHead && (!this.options.data || this.options.data && !this.options.data.headings) && (this.options.sortable = !1), t.tBodies.length && !t.tBodies[0].rows.length && this.options.data && !this.options.data.data) throw new Error("You seem to be using the data option, but you've not defined any rows.");
    this.table = t, this.init();
  }

  static extend(t, e) {
    "function" == typeof e ? o.prototype[t] = e : o[t] = e;
  }

  init(t) {
    if (this.initialized || this.table.classList.contains("dataTable-table")) return !1;
    Object.assign(this.options, t || {}), this.currentPage = 1, this.onFirstPage = !0, this.hiddenColumns = [], this.columnRenderers = [], this.selectedColumns = [], this.render(), setTimeout(() => {
      this.emit("datatable.init"), this.initialized = !0, this.options.plugins && Object.entries(this.options.plugins).forEach(([t, s]) => {
        this[t] && "function" == typeof this[t] && (this[t] = this[t](s, {
          createElement: e
        }), s.enabled && this[t].init && "function" == typeof this[t].init && this[t].init());
      });
    }, 10);
  }

  render(t) {
    if (t) {
      switch (t) {
        case "page":
          this.renderPage();
          break;

        case "pager":
          this.renderPager();
          break;

        case "header":
          this.renderHeader();
      }

      return !1;
    }

    const s = this.options;
    let a = "";

    if (s.data && r.call(this), s.ajax) {
      const t = s.ajax,
            e = new XMLHttpRequest(),
            a = t => {
        this.emit("datatable.ajax.progress", t, e);
      },
            i = s => {
        if (4 === e.readyState) if (this.emit("datatable.ajax.loaded", s, e), 200 === e.status) {
          const a = {};
          a.data = t.load ? t.load.call(this, e) : e.responseText, a.type = "json", t.content && t.content.type && (a.type = t.content.type, Object.assign(a, t.content)), this.import(a), this.setColumns(!0), this.emit("datatable.ajax.success", s, e);
        } else this.emit("datatable.ajax.error", s, e);
      },
            n = t => {
        this.emit("datatable.ajax.error", t, e);
      },
            l = t => {
        this.emit("datatable.ajax.abort", t, e);
      };

      e.addEventListener("progress", a, !1), e.addEventListener("load", i, !1), e.addEventListener("error", n, !1), e.addEventListener("abort", l, !1), this.emit("datatable.ajax.loading", e), e.open("GET", "string" == typeof t ? s.ajax : s.ajax.url), e.send();
    }

    if (this.body = this.table.tBodies[0], this.head = this.table.tHead, this.foot = this.table.tFoot, this.body || (this.body = e("tbody"), this.table.appendChild(this.body)), this.hasRows = this.body.rows.length > 0, !this.head) {
      const t = e("thead"),
            a = e("tr");
      this.hasRows && (Array.from(this.body.rows[0].cells).forEach(() => {
        a.appendChild(e("th"));
      }), t.appendChild(a)), this.head = t, this.table.insertBefore(this.head, this.body), this.hiddenHeader = !s.ajax;
    }

    if (this.headings = [], this.hasHeadings = this.head.rows.length > 0, this.hasHeadings && (this.header = this.head.rows[0], this.headings = [].slice.call(this.header.cells)), s.header || this.head && this.table.removeChild(this.table.tHead), s.footer ? this.head && !this.foot && (this.foot = e("tfoot", {
      html: this.head.innerHTML
    }), this.table.appendChild(this.foot)) : this.foot && this.table.removeChild(this.table.tFoot), this.wrapper = e("div", {
      class: "dataTable-wrapper dataTable-loading"
    }), a += "<div class='dataTable-top'>", a += s.layout.top, a += "</div>", s.scrollY.length ? a += `<div class='dataTable-container' style='height: ${s.scrollY}; overflow-Y: auto;'></div>` : a += "<div class='dataTable-container'></div>", a += "<div class='dataTable-bottom'>", a += s.layout.bottom, a += "</div>", a = a.replace("{info}", s.paging ? "<div class='dataTable-info'></div>" : ""), s.paging && s.perPageSelect) {
      let t = "<div class='dataTable-dropdown'><label>";
      t += s.labels.perPage, t += "</label></div>";
      const i = e("select", {
        class: "dataTable-selector"
      });
      s.perPageSelect.forEach(t => {
        const e = t === s.perPage,
              a = new Option(t, t, e, e);
        i.add(a);
      }), t = t.replace("{select}", i.outerHTML), a = a.replace("{select}", t);
    } else a = a.replace("{select}", "");

    if (s.searchable) {
      const t = `<div class='dataTable-search'><input class='dataTable-input' placeholder='${s.labels.placeholder}' type='text'></div>`;
      a = a.replace("{search}", t);
    } else a = a.replace("{search}", "");

    this.hasHeadings && this.render("header"), this.table.classList.add("dataTable-table");
    const i = e("nav", {
      class: "dataTable-pagination"
    }),
          n = e("ul", {
      class: "dataTable-pagination-list"
    });
    i.appendChild(n), a = a.replace(/\{pager\}/g, i.outerHTML), this.wrapper.innerHTML = a, this.container = this.wrapper.querySelector(".dataTable-container"), this.pagers = this.wrapper.querySelectorAll(".dataTable-pagination-list"), this.label = this.wrapper.querySelector(".dataTable-info"), this.table.parentNode.replaceChild(this.wrapper, this.table), this.container.appendChild(this.table), this.rect = this.table.getBoundingClientRect(), this.data = Array.from(this.body.rows), this.activeRows = this.data.slice(), this.activeHeadings = this.headings.slice(), this.update(), s.ajax || this.setColumns(), this.fixHeight(), this.fixColumns(), s.header || this.wrapper.classList.add("no-header"), s.footer || this.wrapper.classList.add("no-footer"), s.sortable && this.wrapper.classList.add("sortable"), s.searchable && this.wrapper.classList.add("searchable"), s.fixedHeight && this.wrapper.classList.add("fixed-height"), s.fixedColumns && this.wrapper.classList.add("fixed-columns"), this.bindEvents();
  }

  renderPage() {
    if (this.hasHeadings && (s(this.header), this.activeHeadings.forEach(t => this.header.appendChild(t))), this.hasRows && this.totalPages) {
      this.currentPage > this.totalPages && (this.currentPage = 1);
      const t = this.currentPage - 1,
            e = document.createDocumentFragment();
      this.pages[t].forEach(t => e.appendChild(this.rows().render(t))), this.clear(e), this.onFirstPage = 1 === this.currentPage, this.onLastPage = this.currentPage === this.lastPage;
    } else this.setMessage(this.options.labels.noRows);

    let t,
        e = 0,
        a = 0,
        i = 0;

    if (this.totalPages && (e = this.currentPage - 1, a = e * this.options.perPage, i = a + this.pages[e].length, a += 1, t = this.searching ? this.searchData.length : this.data.length), this.label && this.options.labels.info.length) {
      const e = this.options.labels.info.replace("{start}", a).replace("{end}", i).replace("{page}", this.currentPage).replace("{pages}", this.totalPages).replace("{rows}", t);
      this.label.innerHTML = t ? e : "";
    }

    1 == this.currentPage && this.fixHeight();
  }

  renderPager() {
    if (s(this.pagers), this.totalPages > 1) {
      const t = "pager",
            s = document.createDocumentFragment(),
            i = this.onFirstPage ? 1 : this.currentPage - 1,
            n = this.onLastPage ? this.totalPages : this.currentPage + 1;
      this.options.firstLast && s.appendChild(a(t, 1, this.options.firstText)), this.options.nextPrev && s.appendChild(a(t, i, this.options.prevText));
      let l = this.links;
      this.options.truncatePager && (l = ((t, s, a, i, n) => {
        let l;
        const r = 2 * (i = i || 2);
        let h = s - i,
            o = s + i;
        const d = [],
              c = [];
        s < 4 - i + r ? o = 3 + r : s > a - (3 - i + r) && (h = a - (2 + r));

        for (let e = 1; e <= a; e++) if (1 == e || e == a || e >= h && e <= o) {
          const s = t[e - 1];
          s.classList.remove("active"), d.push(s);
        }

        return d.forEach(s => {
          const a = s.children[0].getAttribute("data-page");

          if (l) {
            const s = l.children[0].getAttribute("data-page");
            if (a - s == 2) c.push(t[s]);else if (a - s != 1) {
              const t = e("li", {
                class: "ellipsis",
                html: `<a href="#">${n}</a>`
              });
              c.push(t);
            }
          }

          c.push(s), l = s;
        }), c;
      })(this.links, this.currentPage, this.pages.length, this.options.pagerDelta, this.options.ellipsisText)), this.links[this.currentPage - 1].classList.add("active"), l.forEach(t => {
        t.classList.remove("active"), s.appendChild(t);
      }), this.links[this.currentPage - 1].classList.add("active"), this.options.nextPrev && s.appendChild(a(t, n, this.options.nextText)), this.options.firstLast && s.appendChild(a(t, this.totalPages, this.options.lastText)), this.pagers.forEach(t => {
        t.appendChild(s.cloneNode(!0));
      });
    }
  }

  renderHeader() {
    this.labels = [], this.headings && this.headings.length && this.headings.forEach((t, s) => {
      if (this.labels[s] = t.textContent, t.firstElementChild && t.firstElementChild.classList.contains("dataTable-sorter") && (t.innerHTML = t.firstElementChild.innerHTML), t.sortable = "false" !== t.getAttribute("data-sortable"), t.originalCellIndex = s, this.options.sortable && t.sortable) {
        const s = e("a", {
          href: "#",
          class: "dataTable-sorter",
          html: t.innerHTML
        });
        t.innerHTML = "", t.setAttribute("data-sortable", ""), t.appendChild(s);
      }
    }), this.fixColumns();
  }

  bindEvents() {
    const t = this.options;

    if (t.perPageSelect) {
      const e = this.wrapper.querySelector(".dataTable-selector");
      e && e.addEventListener("change", () => {
        t.perPage = parseInt(e.value, 10), this.update(), this.fixHeight(), this.emit("datatable.perpage", t.perPage);
      }, !1);
    }

    t.searchable && (this.input = this.wrapper.querySelector(".dataTable-input"), this.input && this.input.addEventListener("keyup", () => this.search(this.input.value), !1)), this.wrapper.addEventListener("click", e => {
      const s = e.target.closest("a");
      s && "a" === s.nodeName.toLowerCase() && (s.hasAttribute("data-page") ? (this.page(s.getAttribute("data-page")), e.preventDefault()) : t.sortable && s.classList.contains("dataTable-sorter") && "false" != s.parentNode.getAttribute("data-sortable") && (this.columns().sort(this.headings.indexOf(s.parentNode)), e.preventDefault()));
    }, !1), window.addEventListener("resize", () => {
      this.rect = this.container.getBoundingClientRect(), this.fixColumns();
    });
  }

  setColumns(t) {
    t || this.data.forEach(t => {
      Array.from(t.cells).forEach(t => {
        t.data = t.innerHTML;
      });
    }), this.options.columns && this.headings.length && this.options.columns.forEach(t => {
      Array.isArray(t.select) || (t.select = [t.select]), t.hasOwnProperty("render") && "function" == typeof t.render && (this.selectedColumns = this.selectedColumns.concat(t.select), this.columnRenderers.push({
        columns: t.select,
        renderer: t.render
      })), t.select.forEach(e => {
        const s = this.headings[e];
        t.type && s.setAttribute("data-type", t.type), t.format && s.setAttribute("data-format", t.format), t.hasOwnProperty("sortable") && s.setAttribute("data-sortable", t.sortable), t.hasOwnProperty("hidden") && !1 !== t.hidden && this.columns().hide([e]), t.hasOwnProperty("sort") && 1 === t.select.length && this.columns().sort(t.select[0], t.sort, !0);
      });
    }), this.hasRows && (this.data.forEach((t, e) => {
      t.dataIndex = e, Array.from(t.cells).forEach(t => {
        t.data = t.innerHTML;
      });
    }), this.selectedColumns.length && this.data.forEach(t => {
      Array.from(t.cells).forEach((e, s) => {
        this.selectedColumns.includes(s) && this.columnRenderers.forEach(a => {
          a.columns.includes(s) && (e.innerHTML = a.renderer.call(this, e.data, e, t));
        });
      });
    }), this.columns().rebuild()), this.render("header");
  }

  destroy() {
    this.table.innerHTML = this.initialLayout, this.table.classList.remove("dataTable-table"), this.wrapper.parentNode.replaceChild(this.table, this.wrapper), this.initialized = !1;
  }

  update() {
    this.wrapper.classList.remove("dataTable-empty"), this.paginate(this), this.render("page"), this.links = [];
    let t = this.pages.length;

    for (; t--;) {
      const e = t + 1;
      this.links[t] = a(0 === t ? "active" : "", e, e);
    }

    this.sorting = !1, this.render("pager"), this.rows().update(), this.emit("datatable.update");
  }

  paginate() {
    const t = this.options.perPage;
    let e = this.activeRows;
    return this.searching && (e = [], this.searchData.forEach(t => e.push(this.activeRows[t]))), this.options.paging ? this.pages = e.map((s, a) => a % t == 0 ? e.slice(a, a + t) : null).filter(t => t) : this.pages = [e], this.totalPages = this.lastPage = this.pages.length, this.totalPages;
  }

  fixColumns() {
    if ((this.options.scrollY.length || this.options.fixedColumns) && this.activeHeadings && this.activeHeadings.length) {
      let t,
          s = !1;

      if (this.columnWidths = [], this.table.tHead) {
        if (this.options.scrollY.length && (s = e("thead"), s.appendChild(e("tr")), s.style.height = "0px", this.headerTable && (this.table.tHead = this.headerTable.tHead)), this.activeHeadings.forEach(t => {
          t.style.width = "";
        }), this.activeHeadings.forEach((t, a) => {
          const i = t.offsetWidth,
                n = i / this.rect.width * 100;

          if (t.style.width = n + "%", this.columnWidths[a] = i, this.options.scrollY.length) {
            const t = e("th");
            s.firstElementChild.appendChild(t), t.style.width = n + "%", t.style.paddingTop = "0", t.style.paddingBottom = "0", t.style.border = "0";
          }
        }), this.options.scrollY.length) {
          const t = this.table.parentElement;

          if (!this.headerTable) {
            this.headerTable = e("table", {
              class: "dataTable-table"
            });
            const s = e("div", {
              class: "dataTable-headercontainer"
            });
            s.appendChild(this.headerTable), t.parentElement.insertBefore(s, t);
          }

          const a = this.table.tHead;
          this.table.replaceChild(s, a), this.headerTable.tHead = a, this.headerTable.parentElement.style.paddingRight = this.headerTable.clientWidth - this.table.clientWidth + parseInt(this.headerTable.parentElement.style.paddingRight || "0", 10) + "px", t.scrollHeight > t.clientHeight && (t.style.overflowY = "scroll");
        }
      } else {
        t = [], s = e("thead");
        const a = e("tr");
        Array.from(this.table.tBodies[0].rows[0].cells).forEach(() => {
          const s = e("th");
          a.appendChild(s), t.push(s);
        }), s.appendChild(a), this.table.insertBefore(s, this.body);
        const i = [];
        t.forEach((t, e) => {
          const s = t.offsetWidth,
                a = s / this.rect.width * 100;
          i.push(a), this.columnWidths[e] = s;
        }), this.data.forEach(t => {
          Array.from(t.cells).forEach((t, e) => {
            this.columns(t.cellIndex).visible() && (t.style.width = i[e] + "%");
          });
        }), this.table.removeChild(s);
      }
    }
  }

  fixHeight() {
    this.options.fixedHeight && (this.container.style.height = null, this.rect = this.container.getBoundingClientRect(), this.container.style.height = this.rect.height + "px");
  }

  search(t) {
    return !!this.hasRows && (t = t.toLowerCase(), this.currentPage = 1, this.searching = !0, this.searchData = [], t.length ? (this.clear(), this.data.forEach((e, s) => {
      const a = this.searchData.includes(e);
      t.split(" ").reduce((t, s) => {
        let a = !1,
            i = null,
            n = null;

        for (let t = 0; t < e.cells.length; t++) if (i = e.cells[t], n = i.hasAttribute("data-content") ? i.getAttribute("data-content") : i.textContent, n.toLowerCase().includes(s) && this.columns(i.cellIndex).visible()) {
          a = !0;
          break;
        }

        return t && a;
      }, !0) && !a ? (e.searchIndex = s, this.searchData.push(s)) : e.searchIndex = null;
    }), this.wrapper.classList.add("search-results"), this.searchData.length ? this.update() : (this.wrapper.classList.remove("search-results"), this.setMessage(this.options.labels.noRows)), void this.emit("datatable.search", t, this.searchData)) : (this.searching = !1, this.update(), this.emit("datatable.search", t, this.searchData), this.wrapper.classList.remove("search-results"), !1));
  }

  page(t) {
    return t != this.currentPage && (isNaN(t) || (this.currentPage = parseInt(t, 10)), !(t > this.pages.length || t < 0) && (this.render("page"), this.render("pager"), void this.emit("datatable.page", t)));
  }

  sortColumn(t, e) {
    this.columns().sort(t, e);
  }

  insert(s) {
    let a = [];

    if (t(s)) {
      if (s.headings && !this.hasHeadings && !this.hasRows) {
        const t = e("tr");
        s.headings.forEach(s => {
          const a = e("th", {
            html: s
          });
          t.appendChild(a);
        }), this.head.appendChild(t), this.header = t, this.headings = [].slice.call(t.cells), this.hasHeadings = !0, this.options.sortable = this.initialSortable, this.render("header"), this.activeHeadings = this.headings.slice();
      }

      s.data && Array.isArray(s.data) && (a = s.data);
    } else Array.isArray(s) && s.forEach(t => {
      const e = [];
      Object.entries(t).forEach(([t, s]) => {
        const a = this.labels.indexOf(t);
        a > -1 && (e[a] = s);
      }), a.push(e);
    });

    a.length && (this.rows().add(a), this.hasRows = !0), this.update(), this.setColumns(), this.fixColumns();
  }

  refresh() {
    this.options.searchable && (this.input.value = "", this.searching = !1), this.currentPage = 1, this.onFirstPage = !0, this.update(), this.emit("datatable.refresh");
  }

  clear(t) {
    this.body && s(this.body);
    let e = this.body;

    if (this.body || (e = this.table), t) {
      if ("string" == typeof t) {
        document.createDocumentFragment().innerHTML = t;
      }

      e.appendChild(t);
    }
  }

  export(e) {
    if (!this.hasHeadings && !this.hasRows) return !1;
    const s = this.activeHeadings;
    let a = [];
    const i = [];
    let n, l, r, h;
    if (!t(e)) return !1;
    const o = {
      download: !0,
      skipColumn: [],
      lineDelimiter: "\n",
      columnDelimiter: ",",
      tableName: "myTable",
      replacer: null,
      space: 4,
      ...e
    };

    if (o.type) {
      if ("txt" !== o.type && "csv" !== o.type || (a[0] = this.header), o.selection) {
        if (isNaN(o.selection)) {
          if (Array.isArray(o.selection)) for (n = 0; n < o.selection.length; n++) a = a.concat(this.pages[o.selection[n] - 1]);
        } else a = a.concat(this.pages[o.selection - 1]);
      } else a = a.concat(this.activeRows);

      if (a.length) {
        if ("txt" === o.type || "csv" === o.type) {
          for (r = "", n = 0; n < a.length; n++) {
            for (l = 0; l < a[n].cells.length; l++) if (!o.skipColumn.includes(s[l].originalCellIndex) && this.columns(s[l].originalCellIndex).visible()) {
              let t = a[n].cells[l].textContent;
              t = t.trim(), t = t.replace(/\s{2,}/g, " "), t = t.replace(/\n/g, "  "), t = t.replace(/"/g, "\"\""), t = t.replace(/#/g, "%23"), t.includes(",") && (t = `"${t}"`), r += t + o.columnDelimiter;
            }

            r = r.trim().substring(0, r.length - 1), r += o.lineDelimiter;
          }

          r = r.trim().substring(0, r.length - 1), o.download && (r = "data:text/csv;charset=utf-8," + r);
        } else if ("sql" === o.type) {
          for (r = `INSERT INTO \`${o.tableName}\` (`, n = 0; n < s.length; n++) !o.skipColumn.includes(s[n].originalCellIndex) && this.columns(s[n].originalCellIndex).visible() && (r += `\`${s[n].textContent}\`,`);

          for (r = r.trim().substring(0, r.length - 1), r += ") VALUES ", n = 0; n < a.length; n++) {
            for (r += "(", l = 0; l < a[n].cells.length; l++) !o.skipColumn.includes(s[l].originalCellIndex) && this.columns(s[l].originalCellIndex).visible() && (r += `"${a[n].cells[l].textContent}",`);

            r = r.trim().substring(0, r.length - 1), r += "),";
          }

          r = r.trim().substring(0, r.length - 1), r += ";", o.download && (r = "data:application/sql;charset=utf-8," + r);
        } else if ("json" === o.type) {
          for (l = 0; l < a.length; l++) for (i[l] = i[l] || {}, n = 0; n < s.length; n++) !o.skipColumn.includes(s[n].originalCellIndex) && this.columns(s[n].originalCellIndex).visible() && (i[l][s[n].textContent] = a[l].cells[n].textContent);

          r = JSON.stringify(i, o.replacer, o.space), o.download && (r = "data:application/json;charset=utf-8," + r);
        }

        return o.download && (o.filename = o.filename || "datatable_export", o.filename += "." + o.type, r = encodeURI(r), h = document.createElement("a"), h.href = r, h.download = o.filename, document.body.appendChild(h), h.click(), document.body.removeChild(h)), r;
      }
    }

    return !1;
  }

  import(e) {
    let s = !1;
    if (!t(e)) return !1;
    const a = {
      lineDelimiter: "\n",
      columnDelimiter: ",",
      ...e
    };

    if (a.data.length || t(a.data)) {
      if ("csv" === a.type) {
        s = {
          data: []
        };
        const t = a.data.split(a.lineDelimiter);
        t.length && (a.headings && (s.headings = t[0].split(a.columnDelimiter), t.shift()), t.forEach((t, e) => {
          s.data[e] = [];
          const i = t.split(a.columnDelimiter);
          i.length && i.forEach(t => {
            s.data[e].push(t);
          });
        }));
      } else if ("json" === a.type) {
        const e = (e => {
          let s = !1;

          try {
            s = JSON.parse(e);
          } catch (t) {
            return !1;
          }

          return !(null === s || !Array.isArray(s) && !t(s)) && s;
        })(a.data);

        e && (s = {
          headings: [],
          data: []
        }, e.forEach((t, e) => {
          s.data[e] = [], Object.entries(t).forEach(([t, a]) => {
            s.headings.includes(t) || s.headings.push(t), s.data[e].push(a);
          });
        }));
      }

      t(a.data) && (s = a.data), s && this.insert(s);
    }

    return !1;
  }

  print() {
    const t = this.activeHeadings,
          s = this.activeRows,
          a = e("table"),
          i = e("thead"),
          n = e("tbody"),
          l = e("tr");
    t.forEach(t => {
      l.appendChild(e("th", {
        html: t.textContent
      }));
    }), i.appendChild(l), s.forEach(t => {
      const s = e("tr");
      Array.from(t.cells).forEach(t => {
        s.appendChild(e("td", {
          html: t.textContent
        }));
      }), n.appendChild(s);
    }), a.appendChild(i), a.appendChild(n);
    const r = window.open();
    r.document.body.appendChild(a), r.print();
  }

  setMessage(t) {
    let s = 1;
    this.hasRows ? s = this.data[0].cells.length : this.activeHeadings.length && (s = this.activeHeadings.length), this.wrapper.classList.add("dataTable-empty"), this.label && (this.label.innerHTML = ""), this.totalPages = 0, this.render("pager"), this.clear(e("tr", {
      html: `<td class="dataTables-empty" colspan="${s}">${t}</td>`
    }));
  }

  columns(t) {
    return new l(this, t);
  }

  rows(t) {
    return new n(this, t);
  }

  on(t, e) {
    this.events = this.events || {}, this.events[t] = this.events[t] || [], this.events[t].push(e);
  }

  off(t, e) {
    this.events = this.events || {}, t in this.events != !1 && this.events[t].splice(this.events[t].indexOf(e), 1);
  }

  emit(t) {
    if (this.events = this.events || {}, t in this.events != !1) for (let e = 0; e < this.events[t].length; e++) this.events[t][e].apply(this, Array.prototype.slice.call(arguments, 1));
  }

}

exports.DataTable = o; //# sourceMappingURL=index.js.map

export default exports;
export const __esModule = exports.__esModule,
      DataTable = exports.DataTable;